module.exports = __webpack_public_path__ + "static/media/imageBackgroundInapp.b850482d.png";